import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { faqs } from '@/mocks/homeData';

export default function FAQSection() {
  const { t } = useTranslation();
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            {t('faq.title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            {t('faq.subtitle')}
          </p>
        </div>

        <div className="max-w-2xl mx-auto space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-xl border border-background-200/70 overflow-hidden transition-all"
            >
              <button
                className="w-full flex items-center justify-between gap-3 px-5 py-4 text-left hover:bg-background-100/70 transition-colors"
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
              >
                <span className="text-sm font-medium text-foreground-900">{faq.q}</span>
                <div className={`w-5 h-5 flex items-center justify-center shrink-0 transition-transform duration-200 ${openIdx === idx ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-foreground-500"></i>
                </div>
              </button>
              {openIdx === idx && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}